module.exports = __webpack_public_path__ + "static/media/dotcircle-white.ef5b8488.png";